import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { IStyledOuterWrapperProps } from './HotTopicBanner.types';

const StyledLabel = css`
  margin: ${rem('16px')} 0;
  font-size: ${rem('16px')};
  color: inherit;
`;

export const StyledFirstLabel = styled.span`
  ${StyledLabel}
  margin-right: ${rem('24px')};
  font-size: ${rem('16px')};
  font-weight: bold;
`;

export const StyledSecondLabel = styled.span`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: block;
    ${StyledLabel}
    font-size: ${rem('16px')};
  }
`;

export const StyledCtaLabel = styled.span`
  ${StyledLabel}
  margin-left: ${rem('24px')};
  font-size: ${rem('14px')};
  font-weight: bold;
  text-transform: uppercase;
`;

export const StyledOuterWrapper = styled.a<IStyledOuterWrapperProps>`
  display: flex;
  color: ${({ color, theme }) => (color ? color : theme.colors.main)};
  line-height: 1.4;
  text-decoration: none;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ? backgroundColor : theme.colors.cross.deepBlu};
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    justify-content: center;
  }
`;
